import script from "./storage.vue?vue&type=script&setup=true&lang=js"
export * from "./storage.vue?vue&type=script&setup=true&lang=js"

import "./storage.vue?vue&type=style&index=0&id=d84099a2&scoped=true&lang=sass"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d84099a2"]])

export default __exports__